import React from "react";
import { ShieldCheck, AlertTriangle, ShieldAlert } from "lucide-react";

const CONFIG = {
  Low: {
    label: "Low risk",
    Icon: ShieldCheck,
    cls: "bg-[hsl(var(--risk-low-bg))] text-[hsl(var(--risk-low))] border-[hsl(var(--risk-low))]/25",
  },
  Medium: {
    label: "Medium risk",
    Icon: AlertTriangle,
    cls: "bg-[hsl(var(--risk-medium-bg))] text-[hsl(var(--risk-medium))] border-[hsl(var(--risk-medium))]/25",
  },
  High: {
    label: "High risk",
    Icon: ShieldAlert,
    cls: "bg-[hsl(var(--risk-high-bg))] text-[hsl(var(--risk-high))] border-[hsl(var(--risk-high))]/25",
  },
};

export const RiskBadge = ({ band, size = "md", showIcon = true, ...props }) => {
  const cfg = CONFIG[band] || CONFIG.Low;
  const Icon = cfg.Icon;
  const sizing = size === "sm" ? "text-xs px-2 py-0.5 gap-1" : "text-sm px-2.5 py-1 gap-1.5";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${cfg.cls} ${sizing}`}
      {...props}
    >
      {showIcon && <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} />}
      {cfg.label}
    </span>
  );
};
